import {Component} from '@angular/core';

@Component({
    selector: 'authenticated',
    templateUrl: './authenticated.component.html'
})
export class AuthenticatedComponent {}